import React, { createContext, useContext } from 'react'
import { TaskListItem } from '@myapp/contract'
import { TaskDragState } from './useTaskDrag'

interface TaskRescheduleContextValue {
  taskDragState: TaskDragState | null
  startTaskDrag: (task: TaskListItem, techId: string, e: React.MouseEvent) => void
}

const TaskRescheduleContext = createContext<TaskRescheduleContextValue | null>(null)

export const TaskRescheduleProvider = TaskRescheduleContext.Provider

export function useTaskRescheduleContext(): TaskRescheduleContextValue {
  const ctx = useContext(TaskRescheduleContext)
  if (!ctx) throw new Error('useTaskRescheduleContext must be used inside TaskRescheduleProvider')
  return ctx
}
